import { t } from "../i18n"
import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="asset-form"
export default class extends Controller {
  static targets = ["ownerWrapper", "ownerTypeField", "ownerIdField", "marketplaceWrapper", "marketplaceWarning"]
  static values = {
    marketplaceType: String,
    allowMarketplaceOwner: Boolean
  }

  connect() {
    console.log("Asset form controller connected")
    // Listen for marketplace type changes
    const marketplaceTypeField = document.querySelector('[data-asset-template-target="marketplaceTypeField"]')
    if (marketplaceTypeField) {
      marketplaceTypeField.addEventListener('change', this.updateOwnerVisibility.bind(this))
      // Set initial state based on current value
      this.updateOwnerVisibility({ target: marketplaceTypeField })
    }
  }

  updateOwnerVisibility(event) {
    const marketplaceType = event.target.value
    console.log("Marketplace type changed to:", marketplaceType)

    const isMarketplaceAsset = marketplaceType === 'b2c' || marketplaceType === 'b2b'
    const canKeepOwner = isMarketplaceAsset && this.allowMarketplaceOwnerValue

    // Hide owner field for B2C/B2B assets
    if (this.hasOwnerWrapperTarget) {
      if (isMarketplaceAsset && !canKeepOwner) {
        this.ownerWrapperTarget.style.display = 'none'
        if (this.hasOwnerTypeFieldTarget) this.ownerTypeFieldTarget.value = ''
        if (this.hasOwnerIdFieldTarget) this.ownerIdFieldTarget.value = ''
      } else {
        this.ownerWrapperTarget.style.display = 'block'
      }
    }

    // Show/hide warning message for marketplace assets
    if (this.hasMarketplaceWarningTarget) {
      if (isMarketplaceAsset) {
        this.marketplaceWarningTarget.classList.remove('hidden')
      } else {
        this.marketplaceWarningTarget.classList.add('hidden')
      }
    }

    // Show/hide claim password section for marketplace assets
    const unlockSection = document.getElementById('asset-unlock-code-section')
    if (unlockSection) {
      unlockSection.classList.toggle('hidden', !isMarketplaceAsset)
    }

    // Make marketplace type section more prominent for B2C/B2B
    if (this.hasMarketplaceWrapperTarget) {
      if (isMarketplaceAsset) {
        this.marketplaceWrapperTarget.classList.add('bg-blue-500/10', 'p-4', 'rounded-lg', 'border-2', 'border-blue-500/50')
      } else {
        this.marketplaceWrapperTarget.classList.remove('bg-blue-500/10', 'p-4', 'rounded-lg', 'border-2', 'border-blue-500/50')
      }
    }
  }
}
